import { render, staticRenderFns } from "./SashSelection.vue?vue&type=template&id=4b394a2c&scoped=true&"
import script from "./SashSelection.vue?vue&type=script&lang=js&"
export * from "./SashSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b394a2c",
  null
  
)

export default component.exports